import React, { useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";
import singleFrame from "../../../Assets/Images/Normal-User/Single-frame.png";
import { useHistory } from "react-router-dom";
import { Card, Form, Modal } from "react-bootstrap";
import { usePaytm } from "../../../CustomHooks/usePaytm";
import paytm from "../../../Assets/Images/Payment-img/Paytm_Logo.png";
import strip from "../../../Assets/Images/Payment-img/strip.png";
import payPalLogo from "../../../Assets/Images/Payment-img/PayPal-Logo.wine.png";

function PayAgain(props) {
    const history = useHistory();

    const { makePaytmPayment, paymentBuffer } = usePaytm({
        amount: props?.fee,
        redirectTo: "activities",
        type: props?.event_type,
        event_id: props?.event_id
    })




    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <Card style={{ backgroundColor: "#25272b" }} sx={{ minWidth: 275 }}>
                    <div
                        onClick={props?.onHide}
                        className="d-flex justify-content-end p-2"
                    >
                        <div className="closeNotificationDrop text-center">X</div>
                    </div>
                    <CardContent>
                        <div className="text-center image-middle">
                            <img className="singleFrame-style" src={singleFrame} alt="" />
                            <h3 className="centered">Payment Method</h3>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', paddingTop: '50px', paddingBottom: '50px', minHeight: '200px' }}>
                            {paymentBuffer ?
                                <div class="spinner-border text-warning" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                :
                                <>
                                    <div className="item" style={{ cursor: 'pointer' }} onClick={() => makePaytmPayment()
                                    }>
                                        <img
                                            src={paytm}
                                            alt=""
                                            className="img-fluid payment-img"
                                        />
                                    </div>
                                    <div className="item" style={{ cursor: 'pointer' }}>
                                        <img
                                            src={strip}
                                            alt=""
                                            className="img-fluid payment-img"
                                        />
                                    </div>
                                    <div className="item" style={{ cursor: 'pointer' }}>
                                        <img
                                            src={payPalLogo}
                                            alt=""
                                            className="img-fluid payment-img"
                                        />
                                    </div>
                                </>
                            }

                        </div>


                    </CardContent>
                </Card>
            </Modal.Body>
        </Modal>
    );
}

export default PayAgain